export default __webpack_public_path__ + "static/media/antioquiabello.ff5c0100.jpg";